import type { TranslateDictionary } from './en.js';

export const Sv: TranslateDictionary = {
  'Start airplay': 'Starta AirPlay',
  'Stop airplay': 'Stoppa AirPlay',
  Audio: 'Ljud',
  Captions: 'Textning',
  'Enable captions': 'Aktivera textning',
  'Disable captions': 'Inaktivera textning',
  'Start casting': 'Starta casting',
  'Stop casting': 'Stoppa casting',
  'Casting to {device}': 'Castar till {device}',
  'Enter fullscreen mode': 'Visa i helskärmsläge',
  'Exit fullscreen mode': 'Avsluta helskärmsläge',
  Mute: 'Ljud av',
  Unmute: 'Ljud på',
  'Enter picture in picture mode': 'Aktivera bild-i-bild-läge',
  'Exit picture in picture mode': 'Avsluta bild-i-bild-läge',
  Play: 'Spela upp',
  Pause: 'Pausa',
  'Playback rate': 'Uppspelningshastighet',
  'Playback rate {playbackRate}': 'Uppspelningshastighet {playbackRate}',
  Quality: 'Kvalitet',
  'Seek backward': 'Spola tillbaka',
  'Seek forward': 'Spola framåt',
  Settings: 'Inställningar',
  Auto: 'Auto',
  'audio player': 'ljudspelare',
  'video player': 'videospelare',
  volume: 'Volym',
  seek: 'Sök',
  'closed captions': 'Textning',
  'current playback rate': 'aktuell uppspelningshastighet',
  'playback time': 'uppspelningstid',
  'media loading': 'laddar media',
  settings: 'Inställningar',
  'audio tracks': 'ljudspår',
  quality: 'Kvalitet',
  play: 'spela upp',
  pause: 'pausa',
  mute: 'ljud av',
  unmute: 'ljud på',
  'chapter: {chapterName}': 'kapitel: {chapterName}',
  live: 'direkt',
  Off: 'Av',
  'start airplay': 'starta AirPlay',
  'stop airplay': 'stoppa AirPlay',
  'start casting': 'starta casting',
  'stop casting': 'stoppa casting',
  'enter fullscreen mode': 'visa i helskärmsläge',
  'exit fullscreen mode': 'avsluta helskärmsläge',
  'enter picture in picture mode': 'aktivera bild-i-bild-läge',
  'exit picture in picture mode': 'avsluta bild-i-bild-läge',
  'seek to live': 'gå till direktsändning',
  'playing live': 'spelar direkt',
  'seek back {seekOffset} seconds': 'spola tillbaka {seekOffset} sekunder',
  'seek forward {seekOffset} seconds': 'spola framåt {seekOffset} sekunder',
  'Network Error': 'Nätverksfel',
  'Decode Error': 'Avkodningsfel',
  'Source Not Supported': 'Källa stöds inte',
  'Encryption Error': 'Krypteringsfel',
  'A network error caused the media download to fail.':
    'Ett nätverksfel orsakade att medienedladdningen misslyckades.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Ett mediafel orsakade att uppspelningen avbröts. Mediet kan vara skadat eller din webbläsare stöder inte detta format.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Ett fel som inte stöds inträffade. Servern eller nätverket misslyckades, eller din webbläsare stöder inte detta format.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Mediet är krypterat och det finns inga nycklar för att dekryptera det.',
  'This video is not available.': 'Den här videon är inte tillgänglig.',
  'This video could not be found.': 'Videon kunde inte hittas.',
};
